import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {formatarReal} from "../../../../utils/formatar";
import NumberFormat from "react-number-format";

@inject("store")
@observer
export class DetalhamentoCargo extends Component {

    static propTypes = {
        cargo: PropTypes.object
    };

    constructor(props) {
        super(props);

        this.loginStore = this.props.store.loginStore;
    }

    render() {
        const solicitacaoEtt = this.props.controller.solicitacaoEtt;
        const solicitacao = this.props.controller.solicitacao;
        const exibeSalarioExcecao = this.props.controller.exibeSalarioExcecao;
        const exibeSalarioRequerido = this.props.controller.exibeSalarioRequerido;
        const exibePercentualGDV = this.props.controller.exibePercentualGDV;
        const exibePercentualSalarioGlobo = this.props.controller.exibePercentualSalarioGlobo;
        const tipoGDVString = this.props.controller.tipoGDVString;
        const InsalubridadeCargo = this.props.controller.insalubridadeCargo;
        const periculosidadeCargo = this.props.controller.periculosidadeCargo;
        const percentualSalarioExcecaoEGlobo = this.props.controller.percentualSalarioExcecaoEGlobo;
        const exibeSalarioBase = this.props.controller.exibeSalarioBase;
        //02/05 - Reorganizar campos do salario de exceção

        return (
            <div>
                <h4>Cargo</h4>
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Cargo</Label>
                            <Input type="text" value={_.get(solicitacao, "cargo.nome") + " ("+_.get(solicitacao, "cargo.id")+")"} readOnly />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Categoria</Label>
                            <Input type="text" value={_.get(solicitacao.cargo, "sindicato", "")} readOnly />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Jornada mensal (h)</Label>
                            <Input value={_.get(solicitacao, "cargo.jornadaMensal")} readOnly />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <FormGroup>
                            <Label>Detalhamento do cargo</Label>
                            <Input type="textarea" value={_.get(solicitacao, "cargo.detalhamento")} readOnly />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    {this.props.controller.exibeValorAcheCargo &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Valor salário base + Ache</Label>
                            <Input type="text"
                                   value={formatarReal(_.get(solicitacao, "cargo.salarioBase")+_.get(solicitacao, "cargo.percentualAche")*_.get(solicitacao, "cargo.salarioBase")/100)}
                                   readOnly/>
                        </FormGroup>
                    </Col>
                    }
                    {exibeSalarioBase &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Valor salário base</Label>
                            <Input type="text" value={formatarReal(_.get(solicitacao, "cargo.salarioBase"))} readOnly />
                        </FormGroup>
                    </Col>
                    }
                    {this.props.controller.exibeValorAcheCargo &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Valor do Ache</Label>
                            <Input type="text" value={formatarReal(_.get(solicitacao, "cargo.percentualAche")*_.get(solicitacao, "cargo.salarioBase")/100)} readOnly />
                        </FormGroup>
                    </Col>
                    }
                </Row>
                <Row>
                    {exibeSalarioExcecao &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Salário de exceção</Label>
                            <Input type="text" value={formatarReal(_.get(solicitacao, "salarioExcecao"))} readOnly/>
                        </FormGroup>
                    </Col>
                    }
                    {exibeSalarioExcecao && this.props.controller.solicitacao.cargo && this.props.controller.solicitacao.cargo.percentualAche > 0 && this.props.controller.solicitacao.salarioExcecao > 0 && (
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Valor salário base de exceção</Label>
                            <Input type="text" value={formatarReal(this.props.controller.salarioBaseExcecao)} readOnly/>
                        </FormGroup>
                    </Col>
                    )}
                    {exibeSalarioExcecao && this.props.controller.solicitacao.cargo && this.props.controller.solicitacao.cargo.percentualAche > 0 && this.props.controller.solicitacao.salarioExcecao > 0 && (
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Valor do Ache de exceção</Label>
                            <Input type="text" value={formatarReal(this.props.controller.valorAcheExcecao)} readOnly/>
                        </FormGroup>
                    </Col>
                    )}
                </Row>
                <Row>
                    {exibePercentualSalarioGlobo &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Percentual em relação salário Globo</Label>
                            <Input type="text" value={percentualSalarioExcecaoEGlobo} readOnly/>
                        </FormGroup>
                    </Col>
                    }
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Insalubridade <span style={{fontSize: 10}}>(sobre salário mínimo)</span></Label>
                            <Input type="text" value={InsalubridadeCargo} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Periculosidade <span style={{fontSize: 10}}>(sobre salário base)</span></Label>
                            <Input type="text" value={periculosidadeCargo} readOnly/>
                        </FormGroup>
                    </Col>
                </Row>
                {exibeSalarioRequerido &&
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Valor salário requerido</Label>
                            <Input type="text" value={formatarReal(_.get(solicitacaoEtt, "salarioDiferente"))} readOnly/>
                        </FormGroup>
                    </Col>
                    {this.props.controller.exibeValorAcheRequerido &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Valor do Ache requerido</Label>
                            <Input type="text" value={formatarReal(_.get(solicitacao, "cargo.percentualAche")*_.get(solicitacaoEtt, "salarioDiferente")/100)} readOnly />
                        </FormGroup>
                    </Col>
                    }
                    {this.props.controller.exibeValorAcheRequerido &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Valor salário requerido + Ache requerido</Label>
                            <Input type="text"
                                   value={formatarReal(_.get(solicitacaoEtt, "salarioDiferente")+_.get(solicitacao, "cargo.percentualAche")*_.get(solicitacaoEtt, "salarioDiferente")/100)}
                                   readOnly/>
                        </FormGroup>
                    </Col>
                    }
                </Row>
                }
                {exibePercentualGDV &&
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>GDV {tipoGDVString}<span style={{fontSize: 10}}> (sobre salário base)</span></Label>
                            <NumberFormat suffix="%" maxLength={10} allowNegative={false}
                                          className="form-control" decimalPrecision={1} decimalSeparator=","
                                          value={_.get(solicitacao, "cargo.percentualGDV")}
                                          readOnly/>
                        </FormGroup>
                    </Col>
                </Row>
                }
            </div>
        )
    }
}